import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import moment from 'moment';
import PercentageValue from '../../../common/PercentageValue';
import AbsoluteValue from '../../../common/AbsoluteValue';
import Tooltip from '../../../common/Tooltip';
import EntityCard from '../../../common/SharedEntityCard';
import ConfirmClick from '../../../common/ConfirmClick';
import { splitByThousands, percentageValue } from '../../../../helpers/NumberFormatter';

export const auditReportsSettings = {
	settingsForTable
};

function formatCell(value){return splitByThousands(Number.parseFloat(value).toFixed(2), '$')};

function settingsForTable(onDelete, onUndo){

	let columns = [
			{
				id: 'report_date',
				Header: 'Period',
				accessor: 'report_date',
				Cell: props => <span>{moment(props.value).format('MMM  YYYY')}</span>,
				className: 'table-text-left name-cell',
				headerClassName: 'table-text-left',
			},
		   
			{
				id: 'user_id',
				Header: 'User Name',
				accessor: 'user_id',
				Cell: ({original}) => <span>{original.first_name} {original.last_name}</span>,
				className: 'table-text-left name-cell',
				headerClassName: 'table-text-left',
			},
			
			{
				id: 'email',
				Header: 'Email',
				accessor: 'email',
				className: 'table-text-left name-cell',
				headerClassName: 'table-text-left',
			},

			
			{
				id: 'created_at',
				Header: 'Created At',
				accessor: 'created_at',
				Cell: props => <span>{moment(props.value).format('YYYY-MM-DD')}</span>,
			},

			{
				id: 'actions',
				Header: 'Actions',
				Cell: props => <div>
					<ConfirmClick confirmAction={()=>onUndo(props.original.report_date, props.original.id)} confirmClass="btn add-to-filter" confirmLabel={<i className="fas fa-undo"></i>} confirmPrompt="Undo import for this period?" />
					<ConfirmClick confirmAction={()=>onDelete(props.original.id)} confirmClass="btn add-to-filter" confirmLabel={<i className="fas fa-trash-alt"></i>} confirmPrompt="Delete this period?" />
				</div>,
			}
		];
	return columns; 
}
